import type {Context} from '../types';
import {
  createNewCMSBinding,
  isBoundToCMS,
  getBindingData,
  deleteDynBindProperty,
} from '../utils/legacyBindings';
import {Expressions, type ExpressionPath} from '@packages/systems/wfdl';
import {ERecord, type Expression} from '@packages/systems/wfdl-ast';

const LIGHTBOX_MEDIA_EXPR_PATH: ExpressionPath = [
  {in: 'Record', at: 'json'},
  {in: 'Record', at: 'items'},
];

export default function lightboxMediaCMSLegacyBindingsToUB(context: Context) {
  const {jsonNode} = context.node;
  const lightboxMediaUB = getLightboxMediaUniversalBinding(context);

  const needed = lightboxMediaUB !== null;

  return {
    needed,
    logData: {
      msg: 'Migrate Lightbox Media legacy CMS binding to universal bindings.',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (lightboxMediaUB === null) {
        return;
      }

      deleteDynBindProperty(jsonNode, 'media');

      if (jsonNode.data?.json?.items) {
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.data.json.items;
      }

      jsonNode.bind = Expressions.sparseSetIn(
        jsonNode.bind || ERecord({}),
        LIGHTBOX_MEDIA_EXPR_PATH,
        lightboxMediaUB
      );
    },
  };
}

function getLightboxMediaUniversalBinding(context: Context): Expression | null {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  if (jsonNode.type === 'LightboxWrapper') {
    const dynBindMedia = data.dyn?.bind?.media;
    const bindingData = dynBindMedia ? getBindingData(dynBindMedia) : false;

    if (bindingData && isBoundToCMS(context)) {
      return createNewCMSBinding(
        bindingData.type,
        'lightboxMedia',
        bindingData.slug
      );
    }
  }

  return null;
}
